// ============================================
// guides.js - 行程设计师（团队管理）
// ============================================
export const guides = {
  lorry: {
    id: "lorry",
    name: "Lorry",
    avatar: "images/guides/lorry.jpg",
    intro: "With over 15 years of experience exploring Canada's hidden gems, I bring passion and expertise to every journey.",
    specialties: ["Canada", "North America"],
    language: ["English", "Mandarin"]
  },
  "qi-wei": {
    id: "qi-wei",
    name: "Qi Wei",
    avatar: "images/guides/qi-wei.jpg",
    intro: "Our expert team provides professional Chinese-speaking services and curated luxury experiences across Italy's most beautiful regions.",
    specialties: ["Italy", "Europe"],
    language: ["Mandarin", "Italian", "English"]
  },
  sophia: {
    id: "sophia",
    name: "Sophia",
    avatar: "images/guides/sophia.jpg",
    intro: "French specialist with 12 years of experience in European luxury tours.",
    specialties: ["France", "Europe"],
    language: ["French", "English", "Mandarin"]
  },
  marco: {
    id: "marco",
    name: "Marco",
    avatar: "images/guides/marco.jpg",
    intro: "Italian heritage expert with deep connections to local communities and authentic cultural experiences.",
    specialties: ["Italy", "Mediterranean"],
    language: ["Italian", "English", "Mandarin"]
  },
  emma: {
    id: "emma",
    name: "Emma",
    avatar: "images/guides/emma.jpg",
    intro: "Adventure enthusiast specializing in North American wilderness and outdoor expeditions.",
    specialties: ["Canada", "USA", "Adventure"],
    language: ["English", "French", "Mandarin"]
  }
};